import AddTemplateDialog from './AddTemplateDialog';

export default AddTemplateDialog;
